<template>
  <div class="animated fadeIn">
    <b-card :title="'Site <b>Details</b>'" sub-title="">
      <b-form-row class="form-detail">
        <b-col v-if="facility.icon !== null && facility.icon !== ''" sm="12" lg="3" class="text-center">
          <img :src="facility.icon" class="img-fluid" fluid alt="" />
        </b-col>
        <b-col sm="12" lg="9">
          <b-row>
            <b-col lg="6">
              <b-form-group
                label="Name"
                label-for="name"
                label-class="font-weight-bold"
                :horizontal="true">
                <label class="top-padding-6">{{facility.name}}</label>
              </b-form-group>
              <b-form-group
                label="Description"
                label-for="description"
                label-class="font-weight-bold"
                :horizontal="true">
                <label class="top-padding-6">{{facility.description}}</label>
              </b-form-group>
              <b-form-group
                label="Address"
                label-for="address"
                label-class="font-weight-bold"
                :horizontal="true">
                <label class="top-padding-6">{{facility.address}}</label>
              </b-form-group>
            </b-col>
            <b-col lg="6">
              <b-form-group
                label="QR Code"
                label-for="qrCode"
                label-class="font-weight-bold">
                <img class="icon-preview" :src="facility.qrCode" alt="" />
              </b-form-group>
              <b-button @click="actionToQrCode('print')" size="md" variant="primary" class="btn-pill mr-1" title="Print">
                <i class="fa fa-print"></i>
              </b-button>
              <b-button @click="actionToQrCode('download')" size="md" variant="primary" class="btn-pill btn-download" title="Download">
                <i class="fa fa-download"></i> 
              </b-button>
            </b-col>
          </b-row>
        </b-col>
      </b-form-row>
      <div slot="footer">
        <b-row>
          <b-col md="6" lg="3" class="d-md-down-none">
            <b-button
                  @click="goBack()"
                  size="md"
                  variant="light"
                  class="btn-pill">
              <i class="fa fa-arrow-left"></i> Back
            </b-button>
          </b-col>
        </b-row>
      </div>
    </b-card>
    <div v-show="showPrintQrCode" id="printQrCode">
      <div class="close-button d-print-none">
        <i class="fa fa-times badge-danger" @click="closeQrCodePrinter" aria-hidden="true"></i>
      </div>
      <canvas id="qrCodeCanvas" width="500" height="500"></canvas>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'facilityCreate',
  components: {
    axios
  },
  data () {
    return {
      apiUrlGetDetail: window.AppConfig.apiUrl + 'site',
      facility: {
        uuid: '',
        name: '',
        description: '',
        address: '',
        isAvailable: '',
        isAvailableOnHoliday: '',
        openTime: '',
        closedTime: '',
        icon: '',
        iconMedium: '',
        iconLarge: '',
        createAt: '',
        updateAt: '',
        qrCode: '',
        account: ''
      },
      showPrintQrCode: false
    }
  },
  mounted () {
    this.getDetailInfo()
  },
  watch: {
    '$route.params.id': function (id) {
      this.getDetailInfo()
    }
  },
  methods: {
    getDetailInfo () {
      axios.get(this.apiUrlGetDetail + '/' + this.$route.params.id)
        .then(response => {
          window.setDetailValue(this.facility, response.data)
        })
        .catch(error => {
          this.$store.dispatch('errorMessage', error)
            .then(errMsg => {
              this.$alertify.error(errMsg)
            })
          window.history.back()
        })
    },

    goBack () {
      window.goBack(this)
    },

    actionToQrCode (action) {
      let canvas = document.getElementById('qrCodeCanvas')
      let context = canvas.getContext('2d')
      let imageObj = new Image()
      imageObj.onload = () => {
        context.drawImage(imageObj, 0, 0, 500, 500)
        context.font = '20px Arial'
        context.textAlign = 'center'
        context.fillText(this.facility.name, 250, 470, 500)
        if (action === 'download') {
          /* download as image */
          let link = document.createElement('a')
          link.download = this.facility.name + '.jpeg'
          link.href = document.getElementById('qrCodeCanvas').toDataURL('image/jpeg', 1.0)
          link.click()
        } else {
          this.showPrintQrCode = true
          setTimeout(() => {
            document.body.style.height = document.querySelector('#printQrCode').clientHeight + 'px'
            window.print()
          }, 100)
        }
      }
      imageObj.src = this.facility.qrCode
      // imageObj.src = 'data:image/png;base64,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'
    },

    closeQrCodePrinter () {
      this.showPrintQrCode = false
      document.body.style.height = null
    }
  }
}
</script>

<style>
  .icon-preview, .icon-large, .icon-medium, .icon-small {
    background: transparent !important;
  }
</style>

<style>
  #printQrCode {
    position: fixed;
    background: #fff;
    width: 100%;
    height: 100%;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 100000;
  }
  .close-button i {
    cursor: pointer;
    position: absolute;
    right: 5px;
    top: 4px;
    font-size: 23px;
    background: red;
    padding: 3px;
    color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/views/settings/facility/Detail.vue